<auto-main-navigation [accountId]=""></auto-main-navigation>
<div class="layout">
  <div class="user-list">
    <p-panel class="panel">
      <p-header class="header-row">
        <a href="{{ documentProtocol }}//{{ documentHostname }}/users/add-user">
          <button pButton class="p-button-success user-button" label="Add New User"></button>
        </a>
        <div class="filter-row">
          <p-iconField iconPosition="left" class="input-bar">
            <p-inputIcon class="pi pi-search"></p-inputIcon>
            <input type="text" pInputText [(ngModel)]="userSearchFilter" placeholder="Search Users..." />
          </p-iconField>
        <p-select class="dropdown-bar" [style]="{'min-width': '150px'}" [options]="sortByOptions"
          [(ngModel)]="selectedOption" (onChange)="filterOptions()">
        </p-select>
      </div>
    </p-header>
    <p-virtualscroller
      [items]="filteredMpopUsers | async | userFilterPipe:userSearchFilter"
      scrollHeight="100vh"
      [itemSize]="100"
      [lazy]="true"
      (onLazyLoad)="loadUsersLazy($event)">
      <ng-template let-user pTemplate="item">
        <p-card class="p-card p-card-wrapper" (click)="selectUser(user)"
          [ngClass]="{'p-card-selected': selectedUser === user}">
          <div class="p-grid">
            <div class="p-col-12 p-md-3">
              <div class="user-label-field"><label>{{user.name}}</label></div>
              <div><em style="font-size: 14px">{{user.userType}}</em></div>
            </div>
            <div class="p-col-6 p-md-3">
              <div class="user-label-field"><i class="pi pi-envelope icon-style"></i><label> {{user.email !== '' ? user.email : 'N/A'}}</label></div>
            </div>
            <div class="p-col-6 p-md-3 user-label-field">
              @if (user.phone !== '') {
                <div>
                  <i class="pi pi-phone icon-style"></i><label
                class="user-label-field"> {{user.phone}}</label>
              </div>
            }
          </div>
          @if (user.dealerAccountGroup !== '') {
            <div class="p-col-6 p-md-3 user-label-field dealer-field">
              @if (user.dealerAccountGroup.includes(':dealerAccount')) {
                <div>
                  <i class="pi pi-user icon-style"></i>
                </div>
              }
              @if (user.dealerAccountGroup.includes(':dealerGroup')) {
                <div>
                  <i class="pi pi-users icon-style"></i>
                </div>
              }
              <label class="user-label-field">&nbsp;{{user.dealerAccountGroup.split(':')[0]}}</label>
            </div>
          }
        </div>
      </p-card>
    </ng-template>
  </p-virtualscroller>
</p-panel>
</div>
@if (selectedUser) {
  <div class="user-details">
    <auto-user-profile [user]="selectedUser"
      [isUserSuperAdmin]="isUserSuperAdmin"
      (onUserProfileClose)="closeUserProfile($event)">
    </auto-user-profile>
  </div>
}
</div>
<auto-footer></auto-footer>
